<script setup>
  import { ref, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import CorpJobFairJobPostingsTabView from './CorpJobFairJobPostingsTabView.vue';
  import CorpJobFairInterestedTalentTabView from './CorpJobFairInterestedTalentTabView.vue';
  import CorpJobFairInterviewOffersTabView from './CorpJobFairIntvOffersTabView.vue';

  const route = useRoute();
  const router = useRouter();
  const tabRef = ref(null);

  const tabOptions = [
    {label:'채용공고 관리 및 입사지원 현황', value: 'job-postings'},
    {label:'관심인재', value: 'interested-talent'},
    {label:'보낸 면접제안', value: 'interview-offers'},
  ];

  const selectedTabValue = ref(tabOptions[0].value);

  const onChangeTab = (tab) => {
    selectedTabValue.value = tab.value;
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("tab2", tab.value);
    window.history.replaceState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
  };

  onMounted(() => {
    const tabFromQuery = route.query.tab2;
    if (tabFromQuery && tabOptions.some(opt => opt.value === tabFromQuery)) {
      selectedTabValue.value = tabFromQuery;

      if(tabRef.value) {
        tabRef.value.init(tabFromQuery);
      }
    }
  });
</script>

<template>
  <div class="tab-wrap">
    <KSATab 
      ref="tabRef"
      style="grid-template-columns: repeat(3, 1fr);" class="mt-n-sm mb-lg"
      :options="tabOptions"
      @change="onChangeTab"
    />
  </div>
  <div v-if="selectedTabValue === 'job-postings'">
    <CorpJobFairJobPostingsTabView />
  </div>
  <div v-else-if="selectedTabValue === 'interested-talent'">
    <CorpJobFairInterestedTalentTabView />
  </div>
  <div v-else-if="selectedTabValue === 'interview-offers'">
    <CorpJobFairInterviewOffersTabView />
  </div>
</template>

<style lang="scss" scoped>
.tab-wrap {
  margin-bottom: 20px;
}
</style>